import { render, staticRenderFns } from "./PatientItem.vue?vue&type=template&id=4458a3e2&scoped=true&"
import script from "./PatientItem.vue?vue&type=script&lang=ts&"
export * from "./PatientItem.vue?vue&type=script&lang=ts&"
import style0 from "./PatientItem.vue?vue&type=style&index=0&id=4458a3e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4458a3e2",
  null
  
)

export default component.exports